import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import Logo from '@wix/da-ds/pkg/Logo';
import UserLink from '../../User/Link';
import Modal from '../../Popup/Modal';
import withPopupArt from '../withPopupArt';
import s from './ArtBrandedDesktopPopup.scss';
const ArtBrandedDesktopPopup = ({ artImageSrc, artAuthor, tagline, title, leftContent, className, taglineClassName, overlayClassName, titleClassName, contentClassName, onClose, popupProps = {}, children })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(Modal, _object_spread({
        className: s['modal'],
        onRequestClose: onClose
    }, popupProps), /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['left'],
        style: {
            backgroundImage: artImageSrc && `url(${artImageSrc})`
        }
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['overlay'], overlayClassName)
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['left-content']
    }, /*#__PURE__*/ React.createElement(Logo, {
        className: s['logo'],
        markColor: "white",
        textColor: "white",
        size: "small"
    }), tagline ? /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['tagline'], taglineClassName)
    }, tagline) : leftContent, /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['artist-credit'], artAuthor && s['loaded'])
    }, artAuthor && /*#__PURE__*/ React.createElement(React.Fragment, null, t('common.artistCredit'), /*#__PURE__*/ React.createElement(UserLink, {
        user: artAuthor,
        className: s['user-link']
    }))))), /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['right'], contentClassName)
    }, title && /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['title'], titleClassName)
    }, title), children)));
};
export default withPopupArt(ArtBrandedDesktopPopup);
